import { Button } from 'antd';
import { ClipboardList, Plus, ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { DirectoryTable } from '../../../components/DirectoryTable';
import { useRaiseWorkOrderDrawer } from '../hooks/use-raise-work-order-drawer';
import { useWorkOrderPermissions } from '../hooks/use-work-order-permissions';
import { useWorkOrders } from '../hooks/use-work-orders';
import { buildWorkOrderColumns } from '../components/build-work-order-columns';
import { RaiseWorkOrderDrawer } from '../components/RaiseWorkOrderDrawer';
import { WorkOrdersToolbar } from '../components/WorkOrdersToolbar';

/** Every work order, newest first (gitaumoses4/chukua#473). Anyone with maintenance access sees the list; raising one needs `workorder.manage`. */
export function WorkOrdersPage() {
  const { state, list, isRefreshing, reload, registrations } = useWorkOrders();
  const { canManage } = useWorkOrderPermissions();
  const raise = useRaiseWorkOrderDrawer(reload);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const newButton = canManage && (
    <Button type="primary" icon={<Plus className="size-4" />} onClick={raise.openDrawer}>
      Raise work order
    </Button>
  );

  return (
    <div className="flex flex-col gap-4">
      {newButton && <div className="flex justify-end">{newButton}</div>}
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load work orders" description="Something went wrong loading the list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading work orders" withSearch />}
      {state.status === 'loaded' && (
        <DirectoryTable
          page={state.page}
          columns={buildWorkOrderColumns({ list, registrations })}
          list={list}
          isRefreshing={isRefreshing}
          newButton={newButton}
          emptyIcon={ClipboardList}
          emptyTitle="No work orders yet"
          emptyDescription="Raise a work order when a truck needs repair or service work. It is approved, scheduled, done and then verified by a second person."
          searchPlaceholder="Search title, truck or reference"
          noMatchTitle="No matching work orders"
          toolbar={<WorkOrdersToolbar list={list} />}
        />
      )}
      <RaiseWorkOrderDrawer {...raise.drawerProps} />
    </div>
  );
}
